import Hunt from 'huntjs';

export const SetupInViewDetection = () => {
  const els = document.querySelectorAll('.-detect-in-viewport');
  new Hunt(els, {
    enter: (el) => {
      el.classList.add('-in-viewport');
    },
  });
};